import Button from '@mui/material/Button';
import intl from 'react-intl-universal';
import logger from 'utils/logger';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';

const log = logger.createLogger('DeleteIssueButton');

const propTypes = {
  setIssueDeleteConfirmModalOpen: PropTypes.func.isRequired,
};

const DeleteIssueButton = ({ setIssueDeleteConfirmModalOpen }) => {
  return (
    <Button
      startIcon={<Icon type="trash" />}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '32px',
        verticalAlign: 'middle',
        lineHeight: 1,
        padding: '0 12px',
        whiteSpace: 'nowrap',
        borderRadius: '3px',
        fontSize: '14px',
        transition: 'all 0.1s',
        backgroundColor: '#fff',
        color: '#636363',
      }}
      onClick={() => setIssueDeleteConfirmModalOpen(true)}
      variant="text">
      {intl.get('issue_details_button_delete')}
    </Button>
  );
};

DeleteIssueButton.propTypes = propTypes;
export default DeleteIssueButton;
